import * as breakpoints from "../breakpoints";
import * as colors from "../constants/colors";
import AccordianOpenIndicator from "./AccordianOpenIndicator";
import { css, StyleSheet } from "aphrodite";
import { Column, Row } from "../grid";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";

const styles = StyleSheet.create({
	bodyContainer: {
		color: colors.black4,
		fontFamily:
			"TrebuchetMS, Trebuchet MS, Lucida Grande, Lucida Sans Unicode, Lucida Sans, Tahoma,sans-serif",
		fontSize: 15,
		lineHeight: 1.47,
		paddingTop: 12,
		paddingLeft: 49,
		paddingRight: 16,
		paddingBottom: 10,
	},
	container: {
		[breakpoints.desktopOnly]: {
			":hover": {
				cursor: "pointer",
			},
		},
	},
	titleContainerOpen: {
		[breakpoints.desktopOnly]: {
			":hover": {
				backgroundColor: colors.orange,
			},
		},
		backgroundColor: colors.gray4,
	},
	titleContainerClosed: {
		[breakpoints.desktopOnly]: {
			":hover": {
				backgroundColor: colors.orange,
			},
		},
		backgroundColor: colors.lightOrange,
	},
	titleContainer: {
		paddingTop: 12,
		paddingBottom: 12,
		paddingRight: 38,
		paddingLeft: 10,
		display: "flex",
	},
	titleText: {
		fontFamily:
			"TrebuchetMS, Trebuchet MS, Lucida Grande, Lucida Sans Unicode, Lucida Sans, Tahoma,sans-serif",
		fontSize: 15,
		lineHeight: 1.33,
		color: colors.black4,
		marginLeft: 14,
	},
});

export default class AccordianRow extends PureComponent {
	static propTypes = {
		title: PropTypes.string.isRequired,
		body: PropTypes.string.isRequired,
		isOpen: PropTypes.bool,
		toggleOpen: PropTypes.func.isRequired,
	};

	_toggleOpen = () => {
		this.props.toggleOpen(this.props.title);
	};

	render() {
		return (
			<Row>
				<Column smallFullScreen={true}>
					<div className={css(styles.container)} onClick={this._toggleOpen}>
						<div
							className={css([
								styles.titleContainer,
								this.props.isOpen
									? styles.titleContainerOpen
									: styles.titleContainerClosed,
							])}
						>
							<AccordianOpenIndicator
								isOpen={this.props.isOpen}
								toggleOpen={this._toggleOpen}
							/>
							<div className={css(styles.titleText)}>{this.props.title}</div>
						</div>
						{this.props.isOpen ? (
							<div
								className={css(styles.bodyContainer)}
								dangerouslySetInnerHTML={{ __html: this.props.body }}
							/>
						) : null}
					</div>
				</Column>
			</Row>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/AccordianRow.js